var AT_Slider ={
  
  	owlSlider : function(){
      
      	jQuery(".featured-post-slider").length && jQuery(".featured-post-slider").owlCarousel({
            autoplay	: false
            ,dots 		: true
            ,loop		: false
          	,items		: 1
          
        });
      
        if ( bcMsieVersion.MsieVersion() > 9 || bcMsieVersion.MsieVersion() == 0 ){
          jQuery(".lookbook-slider").length && jQuery(".lookbook-slider").owlCarousel({
              nav 				: false
              ,dots				: true
              ,responsive	:{
                  0:{
                      items:1
                  }
                  ,600:{
                      items:3
                  }
                  ,1000:{
                    items:5
                  }
              }

          });
        }
        else{
          jQuery(".lookbook-slider").length && jQuery(".lookbook-slider").owlCarousel({
              nav 				: false
              ,dots				: true
              ,responsive	:{
                  0:{
                      items:1
                  }
                  ,600:{
                      items:3
                  }
                  ,1000:{
                    items:4
                  }
              }

          });
        }
      
      	jQuery(".related-items").length && jQuery(".related-items").on('initialize.owl.carousel initialized.owl.carousel change.owl.carousel changed.owl.carousel', function(e) {
            var current = e.relatedTarget.current()
            var items = $(this).find('.owl-stage').children()
            var add = e.type == 'changed' || e.type == 'initialized'

            items.eq(e.relatedTarget.normalize(current )).toggleClass('current', add)
        }).owlCarousel({
			nav			: false
          	,dots 		: true
      		,items		: 4
			,responsive : {
                0:{
                	items: 1
                }
            	,480:{
              		items: 2
            	}
            	,768:{
              		items: 3
            	}
            	,1080:{
              		items: 4
            	}
          	}
		});
      
        jQuery('#single-product-tabs').on('shown.bs.tab', function(){
          jQuery(".wear-with-items").length && jQuery(".wear-with-items").on('initialize.owl.carousel initialized.owl.carousel change.owl.carousel changed.owl.carousel', function(e) {
              var current = e.relatedTarget.current()
              var items = $(this).find('.owl-stage').children()
              var add = e.type == 'changed' || e.type == 'initialized'

              items.eq(e.relatedTarget.normalize(current )).toggleClass('current', add)
          }).owlCarousel({
              nav			: false
              ,dots 		: true
              ,items		: 4
              ,responsive : {
                  0:{
                      items: 1
                  }
                  ,480:{
                      items: 2
                  }
                  ,768:{
                      items: 3
                  }
                  ,1080:{
                      items: 4
                  }
              }
          });
        });

        jQuery("#gallery-image").length && jQuery('#gallery-image').bxSlider({
            mode: 'vertical',
            slideWidth: 100,
            minSlides: 6,
            nextText: '<i class="fa fa-angle-down" title="Next"></i>',
            prevText: '<i class="fa fa-angle-up" title="Previous"></i>',
            hideControlOnEnd: true,
            infiniteLoop: false,
            pager: false,
            slideMargin: 10
        });
    	
	}
  
  	,init : function(){
      this.owlSlider();
    }
  
}

/* Check IE */
var bcMsieVersion = {

  MsieVersion: function() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))      // If Internet Explorer, return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
    else                 // If another browser, return 0
      {
      return 0;
    }
  }

  ,init : function(){
    this.MsieVersion();
  }
}

jQuery(document).ready(function($) {
	
	AT_Slider.init();
  	bcMsieVersion.init();
      
});